import React, { useState, useEffect } from "react";
import { getDates, getDayHours } from "./resourcingUtils";
import ShiftDay from "./ShiftDay";
import { Modal } from "antd";
import styles from "../CalendarStyles.module.css";

import CloseIcon from '@mui/icons-material/Close';
import DeleteShiftMetadata from "./DeleteShiftMetadata";

export default function ResoucingWindow({ shifts, job, onEditPlan, refreshShifts, dates }) {

  const [days, setDays] = useState([]);
  const [dayHours, setDayHours] = useState([]);
  const [deleteShiftMetadataModal, setDeleteShiftMetadataModal] = useState(false);
  const [selectedShift, setSelectedShift] = useState(null);

  const onDeleteShift = (shift) => {
    setSelectedShift(shift);
    setDeleteShiftMetadataModal(true);
  }

  const onDeleteShiftClose = (refresh = false) => {
    setDeleteShiftMetadataModal(false);
    if (refresh) {
      refreshShifts();
    }
  }

  useEffect(() => {
    if (dates && dates.job_end_date && dates.job_start_date) {
      let taskDays = getDates(dates.job_start_date, dates.job_end_date);
      let hours = getDayHours();

      setDays(taskDays)
      setDayHours(hours);
    }
  }, [job, dates]);

  return (
    <div className="calendar-modal-window">
      <div className="py-2">
        <div className="drag-selector" style={{ overflow: "scroll hidden" }}>
          <div className="hoursHeader">
            <div className="dayContainer">
              <div className="dayHeadingContainer">
                <div className="dayHeading">
                </div>
              </div>
              <div className="dayTimeContainer">
                <div className="hours-holder">
                  {dayHours.map(hour => (
                    <div className="hourColumn" key={hour.id}>
                      <div className="selecting-hours">
                        <div className="font-weight-bold" style={{ whiteSpace: "nowrap" }}>
                          {hour.name.substr(0, 2)}-{hour.name === "23:00" ? hour.end_name : hour.end_name.substr(0, 2)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {days.map(day => (
            <ShiftDay onDeleteShift={onDeleteShift} key={day.id} day={day} onEditPlan={onEditPlan} shifts={shifts} dayHours={dayHours} />
          ))}
        </div>
      </div>
      <Modal
        className="cs-modal-v2"
        centered
        footer={null}
        visible={deleteShiftMetadataModal}
        maskClosable={false}
        onCancel={() => onDeleteShiftClose()}
        afterClose={() => { setSelectedShift(null) }}
        destroyOnClose={true}
        width={"600px"}
        bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
        closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
      >
        <DeleteShiftMetadata shift={selectedShift} onClose={onDeleteShiftClose} />
      </Modal>
    </div>
  )
}